import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { RecordConversation as RecordConversationModal } from '../../modals/recordConversation';
import { useAnnouncementName } from './callback';
const translatePayload = (node) => {
    const { nextNode } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNode || uuid(),
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNode: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const RecordConversationNodeAttributes = {
    iconName: 'rec',
    label: 'Record conversation',
    helpText: 'All conversations after this action in the flow will be recorded. The recording will be stored under Conversations.',
    color: hexStringToNumber(flowNodeColor.blue),
    translatePayload,
    updateConnection,
    NodeContent: RecordConversationNode,
    ActionModal: RecordConversationModal,
};
export function RecordConversationNode({ node, context, }) {
    const { extraData } = context;
    const { payload } = node;
    const announcement = useAnnouncementName(payload.announcement, extraData);
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Announcement" }), _jsx(Text, { weight: "semibold", text: announcement })] })), [announcement]) }));
}
